import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ data, type = '' }) => {
  // view type
  const [viewType, setViewType] = useState({ view: '' });
  useEffect(() => {
    setViewType({ view: type });
  }, [type]);
  const inpStatus = viewType.view === '' ? '_read' : '';

  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    // familyInitResult[key] = e.target?.value || '';
    // familyInitBind(familyInitResult);
  };

  const labelStyle = { width: '180px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className="_comp_detail_content_div _active">
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_g01')}
            // inputRef={inpRef}
            label="비과세학자금"
            labelPosition="left"
            value={addComma(data.nsal_g01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h05')}
            // inputRef={inpRef}
            label="경호·승선수당"
            labelPosition="left"
            value={addComma(data.nsal_h05 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h06')}
            // inputRef={inpRef}
            label="유아·초중등 관련 비과세"
            labelPosition="left"
            value={addComma(data.nsal_h06 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h07')}
            // inputRef={inpRef}
            label="고등교육법 관련"
            labelPosition="left"
            value={addComma(data.nsal_h07 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h08')}
            // inputRef={inpRef}
            label="특별법 관련"
            labelPosition="left"
            value={addComma(data.nsal_h08 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h09')}
            // inputRef={inpRef}
            label="연구기관 등"
            labelPosition="left"
            value={addComma(data.nsal_h09 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h10')}
            // inputRef={inpRef}
            label="기업부설연구소"
            labelPosition="left"
            value={addComma(data.nsal_h10 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h11')}
            // inputRef={inpRef}
            label="취재수당"
            labelPosition="left"
            value={addComma(data.nsal_h11 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h12')}
            // inputRef={inpRef}
            label="벽지수당"
            labelPosition="left"
            value={addComma(data.nsal_h12 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h13')}
            // inputRef={inpRef}
            label="재해관련급여"
            labelPosition="left"
            value={addComma(data.nsal_h13 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h14')}
            // inputRef={inpRef}
            label="보육교사 근무환경개선비"
            labelPosition="left"
            value={addComma(data.nsal_h14 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h15')}
            // inputRef={inpRef}
            label="사립유치원 수석교사·교사 인건비"
            labelPosition="left"
            value={addComma(data.nsal_h15 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h16')}
            // inputRef={inpRef}
            label="정부공공기관 지방이전기관 종사자 이주수당"
            labelPosition="left"
            value={addComma(data.nsal_h16 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_h17')}
            // inputRef={inpRef}
            label="종교활동비"
            labelPosition="left"
            value={addComma(data.nsal_h17 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_i01')}
            // inputRef={inpRef}
            label="외국정부 등 근무자"
            labelPosition="left"
            value={addComma(data.nsal_i01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_k01')}
            // inputRef={inpRef}
            label="외국주둔군인 등"
            labelPosition="left"
            value={addComma(data.nsal_k01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_m01')}
            // inputRef={inpRef}
            label="국외근로 100만원 한도"
            labelPosition="left"
            value={addComma(data.nsal_m01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_m03')}
            // inputRef={inpRef}
            label="국외근로 일반"
            labelPosition="left"
            value={addComma(data.nsal_m03 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_m04')}
            // inputRef={inpRef}
            label="국외근로 500만원 한도"
            labelPosition="left"
            value={addComma(data.nsal_m04 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_o01')}
            // inputRef={inpRef}
            label="야간근로수당"
            labelPosition="left"
            value={addComma(data.nsal_o01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_p01')}
            // inputRef={inpRef}
            label="비과세 식사대"
            labelPosition="left"
            value={addComma(data.nsal_p01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_q02')}
            // inputRef={inpRef}
            label="보육수당"
            labelPosition="left"
            value={addComma(data.nsal_q02 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_q03')}
            // inputRef={inpRef}
            label="출산지원금(1회)"
            labelPosition="left"
            value={addComma(data.nsal_q03 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_q04')}
            // inputRef={inpRef}
            label="출산지원금(2회)"
            labelPosition="left"
            value={addComma(data.nsal_q04 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_r10')}
            // inputRef={inpRef}
            label="근로장학금"
            labelPosition="left"
            value={addComma(data.nsal_r10 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_r11')}
            // inputRef={inpRef}
            label="직무발명보상금"
            labelPosition="left"
            value={addComma(data.nsal_r11 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_s01')}
            // inputRef={inpRef}
            label="주식매수선택권 비과세"
            labelPosition="left"
            value={addComma(data.nsal_s01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_u01')}
            // inputRef={inpRef}
            label="벤처기업 주식매수선택권"
            labelPosition="left"
            value={addComma(data.nsal_u01 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_y02')}
            // inputRef={inpRef}
            label="우리사주조합인출금 50%"
            labelPosition="left"
            value={addComma(data.nsal_y02 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_y03')}
            // inputRef={inpRef}
            label="우리사주조합인출금 75%"
            labelPosition="left"
            value={addComma(data.nsal_y03 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_y04')}
            // inputRef={inpRef}
            label="우리사주조합인출금 100%"
            labelPosition="left"
            value={addComma(data.nsal_y04 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'nsal_y22')}
            // inputRef={inpRef}
            label="전공의 수련 보조수당"
            labelPosition="left"
            value={addComma(data.nsal_y22 || 0)}
            placeholder="내용을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
